import { EnumModalIcons, EnumModalType } from '../types'
import { type ModalSuccessProps } from './ModalNotificationContent'
import showModalNotification from './showModalNotification'

const showModalNotificationError = (props: Partial<ModalSuccessProps>) => {
  const { title = 'Error', ...rest } = props

  return showModalNotification({
    title,
    ...rest,
    type: EnumModalType.ERROR,
    Icon: EnumModalIcons.Warning,
  })
}

export default showModalNotificationError
